import { DraftReturnShipment } from "./draft-return";

/**
 * Checks if all draft return shipments are eligible for BlueYonder drop-off.
 * A shipment is eligible if it has BlueYonder details with locations.
 */
export function areAllDraftReturnShipmentsBlueYonderEligible(
  shipments: DraftReturnShipment[],
): boolean {
  if (shipments.length === 0) {
    return false;
  }

  return shipments.every((shipment) => !!shipment.blueYonderDetails?.locations);
}

/**
 * Checks if any draft return shipments are eligible for BlueYonder drop-off.
 * A shipment is eligible if it has BlueYonder details with locations.
 */
export function areSomeDraftReturnShipmentsBlueYonderEligible(
  shipments: DraftReturnShipment[],
): boolean {
  return shipments.some((shipment) => !!shipment.blueYonderDetails?.locations);
}

/**
 * Validates that BlueYonder eligibility is consistent across all shipments.
 * Throws an error if there's a mix of BlueYonder-eligible and non-eligible shipments.
 */
export function validateBlueYonderShipmentConsistency(
  shipments: DraftReturnShipment[],
): void {
  const hasBlueYonderEligible =
    areSomeDraftReturnShipmentsBlueYonderEligible(shipments);
  const allBlueYonderEligible =
    areAllDraftReturnShipmentsBlueYonderEligible(shipments);

  if (hasBlueYonderEligible && !allBlueYonderEligible) {
    throw new Error(
      "Partial BlueYonder shipment eligibility is not allowed - all shipments must be either BlueYonder-eligible or none can be",
    );
  }
}
